import { render, staticRenderFns } from "./kpis.vue?vue&type=template&id=a9d7fcd0&"
import script from "./kpis.vue?vue&type=script&lang=js&"
export * from "./kpis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports